import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-6 px-4 bg-burgundy text-white/70 text-center font-lato" data-id="element-81">
        <div className="flex items-center justify-center gap-4 text-xs sm:text-sm" data-id="element-82">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-83">
            Politique de confidentialité
          </button>
          <span className="text-white/30" data-id="element-84">|</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-white transition-colors underline underline-offset-2" data-id="element-85">
            Conditions générales
          </button>
        </div>
        <p className="mt-3 text-[10px] sm:text-xs text-white/40" data-id="element-86">
          © {new Date().getFullYear()} MuseFraise. Tous droits réservés.
        </p>
      </footer>

      <AnimatePresence data-id="element-87">
        {activeModal && <motion.div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setActiveModal(null)} data-id="element-88">
            <motion.div className="bg-white rounded-xl md:rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto" initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          duration: 0.25
        }} onClick={e => e.stopPropagation()} data-id="element-89">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-5 py-4 flex items-center justify-between rounded-t-xl md:rounded-t-2xl" data-id="element-90">
                <h2 className="font-playfair text-lg sm:text-xl font-bold text-burgundy" data-id="element-91">
                  {activeModal === 'privacy' ? 'Politique de confidentialité' : 'Conditions générales de vente'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors" data-id="element-92">
                  <XIcon className="w-5 h-5 text-gray-500" data-id="element-93" />
                </button>
              </div>

              <div className="px-5 py-6 text-sm sm:text-base text-gray-700 font-lato leading-relaxed space-y-4" data-id="element-94">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-95" /> : <TermsContent data-id="element-96" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-97">Dernière mise à jour : avril 2026</p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-98">
        1. Collecte des données
      </h3>
      <p data-id="element-99">
        Lors de votre achat, nous collectons uniquement les informations
        nécessaires au traitement de votre commande : adresse e-mail et
        informations de paiement. Ces données sont traitées de manière sécurisée
        par notre prestataire de paiement.
      </p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-100">
        2. Utilisation des données
      </h3>
      <p data-id="element-101">Vos données personnelles sont utilisées exclusivement pour :</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-102">
        <li data-id="element-103">Vous donner accès à votre pack digital après achat</li>
        <li data-id="element-104">Vous envoyer les communications liées à votre commande</li>
        <li data-id="element-105">Vous informer de nos offres si vous y avez consenti</li>
      </ul>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-106">
        3. Protection des données
      </h3>
      <p data-id="element-107">
        Nous ne vendons, ne louons et ne partageons jamais vos données
        personnelles avec des tiers à des fins commerciales. Vos informations de
        paiement sont traitées via une connexion sécurisée (SSL) et ne sont
        jamais stockées sur nos serveurs.
      </p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-108">
        4. Cookies
      </h3>
      <p data-id="element-109">
        Notre site utilise des cookies essentiels au fonctionnement du service
        et des cookies analytiques pour améliorer votre expérience. Vous pouvez
        désactiver les cookies dans les paramètres de votre navigateur.
      </p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-110">
        5. Vos droits
      </h3>
      <p data-id="element-111">
        Conformément à la réglementation en vigueur, vous disposez d'un droit
        d'accès, de rectification et de suppression de vos données personnelles.
        Pour exercer ces droits, veuillez nous contacter par e-mail.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-400" data-id="element-112">Dernière mise à jour : avril 2026</p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-113">
        1. Objet
      </h3>
      <p data-id="element-114">
        Les présentes conditions générales de vente régissent l'achat du pack
        digital « Maman Chérie » par MuseFraise. En passant commande, vous
        acceptez sans réserve les présentes conditions.
      </p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-115">
        2. Produit
      </h3>
      <p data-id="element-116">
        Le pack « Maman Chérie » est un produit 100% digital comprenant des
        guides PDF haute définition, des fichiers imprimables et des ressources
        de décoration. L'accès est fourni immédiatement après le paiement via un
        lien de téléchargement.
      </p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-117">
        3. Prix et paiement
      </h3>
      <p data-id="element-118">
        Le prix du pack est indiqué en dollars canadiens (CAD), toutes taxes
        comprises. Le paiement est sécurisé et traité par notre prestataire de
        paiement. L'accès au produit est délivré instantanément après
        confirmation du paiement.
      </p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-119">
        4. Garantie de remboursement
      </h3>
      <p data-id="element-120">
        Vous bénéficiez d'une garantie « satisfait ou remboursé » de 30 jours à
        compter de la date d'achat. Si vous n'êtes pas satisfait(e), vous pouvez
        demander un remboursement intégral par simple demande par e-mail, sans
        justification requise. Le contenu digital reste accessible même après
        remboursement.
      </p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-121">
        5. Propriété intellectuelle
      </h3>
      <p data-id="element-122">
        L'ensemble du contenu du pack (textes, images, designs, fichiers
        imprimables) est protégé par le droit d'auteur. L'achat vous confère un
        droit d'utilisation personnel et non-commercial. Toute reproduction,
        redistribution ou revente est strictement interdite.
      </p>

      <h3 className="font-playfair font-bold text-burgundy text-base sm:text-lg" data-id="element-123">
        6. Limitation de responsabilité
      </h3>
      <p data-id="element-124">
        MuseFraise fournit des guides et ressources à titre informatif. Les
        résultats peuvent varier selon les ingrédients utilisés et les
        conditions de préparation. MuseFraise ne saurait être tenu responsable
        des résultats obtenus.
      </p>
    </>;
}